import { Clause } from '../types';

export const cleanDuplicatedNumbering = (text: string): string => {
  if (!text) return text;

  let cleaned = text.trim();

  cleaned = cleaned.replace(/^(第[一二三四五六七八九十百千万零〇两]+条)\1/, '$1');
  cleaned = cleaned.replace(/^(第\d+条)\1/, '$1');

  const allNums = cleaned.match(/\d+\.\d+/g) || [];
  if (allNums.length >= 2) {
    for (let i = 1; i < allNums.length; i += 1) {
      const num = allNums[i];
      const doubled = num + num;
      if (cleaned.startsWith(doubled)) {
        cleaned = `${num} ${cleaned.substring(doubled.length).trimStart()}`;
        break;
      }
    }
  }

  const numberingMatch = cleaned.match(/^(\d+\.\d+)/);
  if (numberingMatch) {
    const numbering = numberingMatch[1];
    const escapedNum = numbering.replace(/\./g, '\\.');
    const pattern = new RegExp(`${escapedNum}\\s+`, 'g');
    const matches: { index: number; length: number }[] = [];
    let match;

    while ((match = pattern.exec(cleaned)) !== null) {
      matches.push({ index: match.index, length: match[0].length });
    }

    if (matches.length >= 2) {
      const secondMatch = matches[1];
      const firstPart = cleaned.substring(0, secondMatch.index).trim();
      const secondPart = cleaned.substring(secondMatch.index + secondMatch.length).trim();
      const firstContentMatch = firstPart.match(new RegExp(`^${escapedNum}\\s+(.+)$`, 's'));

      if (firstContentMatch) {
        const firstContent = firstContentMatch[1].trim();
        const minLen = Math.min(firstContent.length, secondPart.length);
        if (minLen > 5) {
          const checkLen = Math.min(20, minLen);
          if (firstContent.substring(0, checkLen) === secondPart.substring(0, checkLen)) {
            return firstPart;
          }
        }
      }
    }
  }

  const lines = cleaned.split('\n');
  if (lines.length > 1) {
    const uniqueLines: string[] = [];
    const seen = new Set<string>();
    for (const line of lines) {
      const trimmed = line.trim();
      if (trimmed && !seen.has(trimmed)) {
        seen.add(trimmed);
        uniqueLines.push(line);
      }
    }
    cleaned = uniqueLines.join('\n');
  }

  return cleaned;
};

export const extractClauseNumber = (value?: string | null): string => {
  const cleaned = cleanDuplicatedNumbering(value || '');
  const match = cleaned.match(/^(\d+(?:\.\d+)*|第\s*[一二三四五六七八九十百千万零〇两\d]+\s*[条章节款项]?)(?=$|[\s、,，.．:：;；)\]）-])/);
  return match?.[1].replace(/\s+/g, '') || '';
};

export const getClauseNumberLabel = (clause: Pick<Clause, 'clause_no' | 'sequence'>): string => {
  const extracted = extractClauseNumber(clause.clause_no);
  if (extracted) return extracted;

  const cleaned = cleanDuplicatedNumbering(clause.clause_no || '');
  if (cleaned && cleaned.length <= 16) return cleaned;

  return `#${clause.sequence}`;
};

export const getClauseTitleLabel = (clause: Pick<Clause, 'title' | 'clause_no'>): string => {
  const title = cleanDuplicatedNumbering(clause.title || '');
  if (title) return title;

  const clauseNo = cleanDuplicatedNumbering(clause.clause_no || '');
  const number = extractClauseNumber(clauseNo);
  if (!number) return '';

  return clauseNo
    .slice(clauseNo.indexOf(number) + number.length)
    .replace(/^[\s、,，.．:：;；)\]）-]+/, '')
    .trim();
};

